import { useState, useEffect } from "react"
import {
  projectAuth,
  projectStorage,
  projectFirestore,
} from "../firebase/config"
import { useAuthContext } from "./useAuthContext"
import defaultImg from "../assets/default.jpeg"

export const useSignup = () => {
  const [isCancelled, setIsCancelled] = useState(false)
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthContext()

  const signup = async (email, password, displayName, thumbnail) => {
    setError(null)
    setIsPending(true)

    try {
      // signup
      const res = await projectAuth.createUserWithEmailAndPassword(
        email,
        password
      )

      if (!res) {
        throw new Error("Could not complete signup")
      }

      // //upload user thumbnail
      // const uploadPath = `thumbnails/${res.user.uid}/${thumbnail.name}`
      // const img = await projectStorage.ref(uploadPath).put(thumbnail)
      // const imgUrl = await img.ref.getDownloadURL()

      // let imgUrl = null
      // if (thumbnail) {
      //   const uploadPath = `thumbnails/${res.user.uid}/${thumbnail.name}`
      //   const img = await projectStorage.ref(uploadPath).put(thumbnail)
      //   imgUrl = await img.ref.getDownloadURL()
      // } else {
      //   // Use default profile picture URL if thumbnail is not provided
      //   imgUrl =
      //     "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcQvzXfX9CLB37i-Ko8-cA9rl1l2oPF6kIOueuaWmibzhyrx-tnn"
      // }

      let imgUrl = null
      if (thumbnail) {
        const uploadPath = `thumbnails/${res.user.uid}/${thumbnail.name}`
        const img = await projectStorage.ref(uploadPath).put(thumbnail)
        imgUrl = await img.ref.getDownloadURL()
      } else {
        // Use default profile picture URL if thumbnail is not provided
        const defaultUploadPath = `thumbnails/${res.user.uid}/default.jpeg`
        await projectStorage
          .ref(defaultUploadPath)
          .putString(defaultImg, "data_url")
        imgUrl = await projectStorage.ref(defaultUploadPath).getDownloadURL()
      }

      // add display AND PHOTO_URL name to user
      await res.user.updateProfile({ displayName, photoURL: imgUrl })

      // create a user document
      await projectFirestore.collection("users").doc(res.user.uid).set({
        online: true,
        displayName,
        photoURL: imgUrl,
      })

      // dispatch login action
      dispatch({ type: "LOGIN", payload: res.user })

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
    } catch (err) {
      if (!isCancelled) {
        setError(err.message)
        setIsPending(false)
      }
    }
  }

  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  return { signup, error, isPending }
}
